/**
 * @ngdoc factory
 * @name editableField.factory:EditableFields
 * @description
 * Manages the state of all editable fields on the page
 */
// @ngInject
module.exports = function () {
    var fields = [];
    var EDIT = 'edit';
    var SAVE = 'save';
    var CANCEL = 'cancel';

    // Create a new `field_data` object for every $field element added
    function addField($field) {
        fields.push({ state: null, element: $field });
    }

    // Returns the `field_data` object containing the given $field element
    function getFieldData($field) {
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].element === $field) {
                return fields[i];
            }
        }
    }

    // Returns the boolean state of the a `field_data` object
    function getFieldState($field) {
        var field_data = getFieldData($field);
        if (field_data) {
            return field_data.state;
        }
        return false;
    }

    // Sets a `field_data` object state to a given boolean value
    function setFieldState($field, state) {
        var field_data = getFieldData($field);
        if (field_data) {
            field_data.state = state;
        }
    }

    // Returns an array of `field_data` objects flagged as `active`
    function getActiveFields() {
        return fields.filter(function (field) {
            return field.state === EDIT;
        });
    }

    return {
        addField: addField,
        getFieldState: getFieldState,
        setFieldState: setFieldState,
        getActiveFields: getActiveFields,
        EDIT: EDIT,
        SAVE: SAVE,
        CANCEL: CANCEL
    };
};
